import {
  ArtistRolesEnum,
  DeauthorizedReasonEnum,
  Roles,
} from 'src/Constants/enums'

import type { ID } from './common'
import type { Playlist } from './playlists'
import type { Payout } from './payments'

export interface User {
  artist?: {
    artist_role?: ArtistRolesEnum
  }
  isReferral: boolean
  intercomHash: string | null
  isBlocked: boolean
  first_name: string
  last_name: string
  ip: string
  last_activity: string
  isArtist: boolean
  user_photo_url?: string
  is_email_confirmed: boolean
  is_first_campaign: boolean
  is_new_term?: boolean
  are_terms_accepted: boolean | null
  createdAt: string
  email: string
  geo: {
    country: string
  }
  id: ID
  phone_number: string
  role: Roles
  terms_position: number | null
  playlist_requirement: boolean
  followerCount: number
  balance?: number
  country?: string | null

  created_at?: string
  spotify_id?: string
  access_token?: string
  refresh_token?: string
  spotifyId: string | null
  influencerId: number
  updatedAt?: string
  isEmailConfirmed: boolean
  lastActivity: string
  isTiktokAllowed?: boolean
}

export type Curator = {
  are_terms_accepted: boolean
  email: string
  createdAt: string
  id: number
  ip: string
  first_name: string
  last_activity: string
  last_name: string
  spotify_id: string
  user_photo_url: string
  verified: boolean
  terms_position: number
  is_new_feed: boolean
  isArtist: boolean
  username: string
  negative_responses: number
  playlist_followers: Array<number>
  followers_count: number
  playlists_count: number
  rating: number
  adding_rate: number
  Payouts: Array<Payout>
  Playlists: Array<Playlist>

  user_id: number

  User: User
  Recipient: {
    is_checking_needed: boolean
    country: string
  }
}

export interface UsersMeResponse {
  id: number
  createdAt: string
  updatedAt: string
  email: string
  role: Roles
  firstName?: string
  lastName?: string
  userPhotoUrl?: string
  isEmailConfirmed: boolean
  lastActivity?: string
  spotifyId?: string
  intercomHash: string
  isReferral: boolean
  hasPassword: boolean
  phoneNumber: string | null
  referralCode: string | null
  isEmailBounced: boolean
  balance: number
  countryCode: string

  metaData: UsersMeMetaData | null
}

type ProfileUserMetaData = ArtistUserMetaData | CuratorUserMetaData
type UsersMeMetaData = ProfileUserMetaData | CreatorUserMetaData

export interface ArtistUserMetaData {
  id: number
  createdAt: string
  updatedAt: string
  role: ArtistRolesEnum
}

export interface CuratorUserMetaData {
  id: number
  createdAt: string
  updatedAt: string
  areTermsAccepted: boolean | null
  inBlacklist: boolean | null
  isBlocked: boolean
  termsPosition: number | null
  verified: boolean | null
  preReleaseRulesAcceptedAt?: string | null
  userPhotoUrl?: string | null
}

export interface CreatorUserMetaData {
  id: number
  createdAt: string
  updatedAt: string
  nickname: string
  followerCount: number
  rate: number
  isBlocked: boolean
  tiktokRefreshTokenExpiresIn: string
  tiktokNickname?: string
  deauthorizedReason?: DeauthorizedReasonEnum | null
  deauthorizedAt?: string | null
}

export interface FormDataProps {
  firstName: string
  lastName: string
  role: string
  email: string
  phoneNumber?: string | null
}

export interface SearchTrackFormDataProps {
  searchInput: string
}

export enum InfluencerRegisterEnum {
  JOIN = 'join',
  CONNECT = 'connect',
  CONNECTED = 'connected',
  FORM = 'form',
  CONFIRMATION = 'confirmation',
  COMPLETED = 'completed',
  ERROR = 'error_connect',
}
